import { handleActions } from "redux-actions";
import {
  SHOW_FILTER_OVERLAY,
  HIDE_FILTER_OVERLAY,
  UPDATE_VIEWPORT_CATEGORY,
  UPDATE_SCREEN_DIMENSIONS,
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT,
  SET_THREE_LINE_LAYOUT
} from "./constants";

const initialState = {
  isFilterOverlayVisible: false,
  viewportCategory: SMALL_VIEWPORT,
  screenDimensions: {
    width: 0,
    height: 0
  }
};

const iNoBounce = CLIENT
  ? require("inobounce")
  : { enable: () => {}, disable: () => {} };

const validateViewport = (state, viewport) =>
  [SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT].includes(viewport)
    ? viewport
    : state.viewportCategory;

export default handleActions(
  {
    [SHOW_FILTER_OVERLAY]: state => {
      document.body.classList.add("chrome-hide-overflow");
      iNoBounce.enable();

      return { ...state, isFilterOverlayVisible: true };
    },
    [HIDE_FILTER_OVERLAY]: state => {
      document.body.classList.remove("chrome-hide-overflow");
      iNoBounce.disable();

      return { ...state, isFilterOverlayVisible: false };
    },
    [UPDATE_VIEWPORT_CATEGORY]: (state, action) => ({
      ...state,
      viewportCategory: validateViewport(state, action.payload.viewportCategory)
    }),
    [UPDATE_SCREEN_DIMENSIONS]: (state, action) => ({
      ...state,
      screenDimensions: action.payload.screenDimensions
    }),
    [SET_THREE_LINE_LAYOUT]: (state, action) => ({
      ...state,
      threeLineLayout: action.payload.threeLineLayout
    })
  },
  initialState
);
